// NOTE: Hallway label ZZZ is to override potential labels and force 'z'
export const defaultTaggingRules = {
  'Stairwell': {
    floor: /^(\d+)/,
    label: /Stairwell (\w)/,
    category: 'Stairwell',
  },
  'Hallway': {
    floor: /^(\d+)/,
    label: 'ZZZ',
    category: 'Hallway',
  },
  'Outdoor': {
    floor: 9999,
    label: 'ZZZ',
    category: 'Outdoor',
  },
  'Elevator Car': {
    floor: /^(\d+)/,
    label: 'ZZZ',
    category: 'Elevator',
  },
  'Elevator Banks': {
    floor: /^(\d+)/,
    label: 'ZZZ',
    category: 'Hallway',
  },
}

export const westchesterTaggingRules = {
  'Center: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'Center',
  },
  'Franklin: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'Franklin',
  },
  'Garden: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'Garden',
  },
  'North: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'North',
  },
  'West-1: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'West 1',
  },
  'West-2: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'West 2',
  },
  'West-3: ': {
    floor: 9999,
    label: 'ZZZ',
    category: 'West 3',
  },
}

export function tagCamera (camera, taggingRules) {
  const rules = Object.keys(taggingRules)
  const categories = []

  for (var rule in taggingRules) {
    categories.push(taggingRules[rule].category)
  }

  rules.forEach(key => {
    const ruleMatch = camera.description.match(key)

    if (ruleMatch) {
      const rule = taggingRules[key]

      if (!camera.label || camera.label !== rule.label) {
        const labelMatch = camera.description.match(rule.label)
        camera.label = labelMatch ? labelMatch[1] : 'Z'
      }

      if (!camera.floor || camera.floor !== rule.floor) {
        const floorMatch = camera.description.match(rule.floor)
        camera.floor = floorMatch ? floorMatch[1] : 9999
      }

      camera.category = rule.category
    } else {
      if (!(categories.includes(camera.category))) {
        camera.category = 'Other'
        camera.floor = 9999
        camera.label = 'Z'
      }
    }
  })

  return camera
}

const cmpDescriptions = (a, b) => ((a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0))
const cmpFloors = (a, b) => (a.floor - b.floor)
const cmpLabels = (a, b) => ((a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))

export function sortCameras (camerasList) {
  var sortedCameras = camerasList.sort((a, b) => {
    var cd = cmpDescriptions(a, b)
    var cf = cmpFloors(a, b)
    var cl = cmpLabels(a, b)
    if (cl) {
      return cl
    } else if (cf) {
      return cf
    } else {
      return cd
    }
  })

  return sortedCameras
}
